export default "__VITE_ASSET__tjs7_JW___"